<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Issued Visa Report</h3>
        <span>
                    <sidebar-filter-button class="mr-2">
                        <div class="px-2">
                            <v-text-field
                                :elevation="0"
                                class="mb-4"
                                flat
                                hide-details
                                placeholder="Search by typing here"
                                prepend-inner-icon="search"
                                solo
                                v-model="filters.query"
                                @keypress.enter="fetchFiltersData"
                                outlined
                            ></v-text-field>
                            <v-text-field
                                class="hidden-sm-and-down mb-4"
                                flat
                                hide-details
                                placeholder="Visa number"
                                prepend-inner-icon="search"
                                solo
                                v-model="filters.visa_number"
                                @keypress.enter="fetchFiltersData"
                                outlined
                            ></v-text-field>
                            <v-text-field
                                class="hidden-sm-and-down mb-4"
                                flat
                                hide-details
                                placeholder="Document number"
                                prepend-inner-icon="search"
                                solo
                                v-model="filters.document_number"
                                @keypress.enter="fetchFiltersData"
                                outlined
                            ></v-text-field>
                            <v-autocomplete
                                :items="offices"
                                @change="fetchFiltersData"
                                chips
                                clearable
                                deletable-chips
                                flat
                                hide-details
                                item-text="name"
                                item-value="id"
                                class="mb-4"
                                label="Office"
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.office"
                                multiple
                                outlined
                            ></v-autocomplete>
                            <v-autocomplete
                                :items="visa_types"
                                @change="fetchFiltersData"
                                chips
                                clearable
                                deletable-chips
                                flat
                                hide-details
                                item-text="type"
                                item-value="id"
                                class="mb-4"
                                label="Visa Type"
                                multiple
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.visa_type"
                                outlined
                            ></v-autocomplete>

                                  <v-select
                                      :items="purpose_of_arrivals"
                                      flat
                                      solo
                                      outlined
                                      label="Purpose of visa"
                                      v-model="filters.purpose"
                                      clearable
                                      hide-details
                                      prepend-inner-icon="filter_list"
                                      @change="fetchFiltersData"
                                      class="mb-4"
                                  />
                            <v-autocomplete
                                :items="countries"
                                chips
                                clearable
                                deletable-chips
                                flat
                                hide-details
                                item-text="country_name"
                                item-value="id"
                                class="mb-4"
                                label="Filter By Country"
                                multiple
                                prepend-inner-icon="filter_list"
                                solo
                                v-model="filters.country"
                                @change="fetchFiltersData"
                                outlined
                            />
                            <v-flex class="mb-4">
                                <custom-date-range-picker @change="fetchFiltersData"
                                                          v-model="filters.date_range"
                                                          :outlined="true"></custom-date-range-picker>
                            </v-flex>
                            <officer-select-filter
                                :outlined="true"
                                v-model="filters.officers"
                                @input="fetchFiltersData"
                                class="mb-4"
                            ></officer-select-filter>
                          <v-select
                              :items="payment_type"
                              flat
                              solo
                              outlined
                              label="Payment Type"
                              v-model="filters.payment_type"
                              item-text="text"
                              item-value="value"
                              clearable
                              hide-details
                              prepend-inner-icon="filter_list"
                              @change="fetchFiltersData"
                              class="mb-4"
                          />
                          <v-checkbox
                              @change="fetchFiltersData"
                              v-model="filters.printed_visa"
                              label="Printed Issued Visa"
                          ></v-checkbox>
                        </div>
                    </sidebar-filter-button>
                        <export-excel-button :export-data="exportData"
                                             v-if="$oauth.checkIfHasPermission(['export issued-visa'])"></export-excel-button>
          <refresh-button :click-function="refreshData"></refresh-button>
        </span>

      </v-flex>

      <v-flex lg12>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="data"
                :loading="loading"
                :options.sync="pagination"
                class="elevation-0"
                hide-default-footer
                v-if="$oauth.checkIfHasPermission(['read issued-visa'])"
            >
              <template v-slot:item.full_name="{ item }">
                <span class="font-weight-bold" style="font-size: 13px;"> {{ item.full_name }} </span>
                <br>
                <span style="font-size: 12px;">({{ item.document_number }})</span>
              </template>
              <template v-slot:item.visa_number="{ item }">
                <span class="font-weight-bold" style="font-size: 13px;"> {{ item.visa_number }} </span>
                <br>
                <span style="font-size: 12px;" v-if="item.sticker_serial_no">({{ item.sticker_serial_no }})</span>
              </template>
              <template v-slot:item.visa_type="{ item }">
                <span class="font-weight-bold" style="font-size: 13px;"> {{ item.visa_type }} </span>
                <br>
                <span style="font-size: 11px;">{{ item.condition }}</span><br>
                <span v-if="item && item.extra && item.extra.application_data && item.extra.application_data.other_name_of_academic_institution" style="font-size: 11px;">
                  ({{ item.extra.application_data.other_name_of_academic_institution }})
              </span>
                <span v-if="item && item.extra && item.extra.application_data && item.extra.application_data.organization_name" style="font-size: 11px;">
                  ({{ item.extra.application_data.organization_name }})
              </span>
              </template>
              <template v-slot:item.officer="{ item }">
                <span class="font-weight-bold" style="font-size: 13px;"> {{ item.officer }} </span>
                <br>
                <span style="font-size: 11px;">{{ item.office_name }}</span>
              </template>
              <template v-slot:item.country="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ item.country_code }}</span>
                  </template>
                  <span>{{ item.country }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read traveller-history')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/travellers-history/view/'+item.traveller"
                        :to="'/system/travellers-history/view/'+item.traveller"
                        x-small>
                      <v-icon small>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>View Traveller</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="view(item)"
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small>
                      <v-icon small>mdi-equal-box</v-icon>
                    </v-btn>
                  </template>
                  <span>View Visa Details</span>
                </v-tooltip>
                <v-tooltip top
                           v-if="$oauth.checkIfHasPermission('alter visa-request') && item.updated_at === null">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        @click="editVisa(item)"
                        x-small>
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <issued-visa-footer :disable-next="disableNext" :disable-prev="disablePrev"
                                :items-loading="totalItemsLoading"
                                :perPage="pagination.itemsPerPage"
                                :showing-of="showingOf"
                                :total="total"
                                @getCount="getCount"
                                @nextClick="handleNextClick"
                                @prevClick="handlePrevClick"
                                @rowChanged="fetchDataWithRow"
            ></issued-visa-footer>
          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-if="$oauth.checkIfHasPermission(['alter visa-request']) && visa.updated_at === null"
        v-model="form"
        width="700">
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Edit Visa Information</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-text-field
                      :rules="[rules.required]"
                      label="Expiry Date *"
                      outlined
                      type="date"
                      v-model="visa.expiry_date"
                  ></v-text-field>
                  <v-text-field
                      :rules="[rules.required]"
                      label="Valid Reason *"
                      outlined
                      type="text"
                      v-model="visa.reason"
                  ></v-text-field>

                  <!--                                    <file-input-->
                  <!--                                                :required="true"-->
                  <!--                                                label="Image *"-->
                  <!--                                                v-model="visa.visa"-->
                  <!--                                                :file-size="1024"></file-input>-->
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="visa = false"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="updateVisa"
              class="white--text"
              color="blue darken-3"
          >Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import ExportExcelButton from "../../components/ExportExcelButton";
import {validationMixin} from "../../mixins/validationMixin";
import SidebarFilterButton from "../../components/SidebarFilterButton";


import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import FileInput from "../../components/FileInput";
import OfficerSelectFilter from "../../components/filters/OfficerSelectFilter";
import {fetchDynamicValues} from "@/helpers/dynamicValueHelper";
import RefreshButton from "@/components/RefreshButton";

export default {
  data() {
    return {
      title: "Issued Visa",
      headers: [
        {
          text: 'S.N.',
          value: 's_no',
          sortable: false
        },
        {
          text: "Full Name",
          value: "full_name",
          sortable: false
        },
        {
          text: "Visa Number",
          value: "visa_number",
          sortable: false
        },
        {
          text: "Country",
          value: "country",
          sortable: false
        },
        {
          text: "Visa Type",
          value: "visa_type",
          sortable: false
        },
        {
          text: "Purpose of visa",
          value: "purpose_of_visa",
          sortable: false
        },
        {
          text: "Officer",
          value: "officer"
        },
        {
          text: "Issued Office",
          value: "issued_office_name"
        },
        {
          text: "Approved Date",
          value: "approved_at"
        },
        {
          text: "Action",
          value: "action",
          sortable: false
        }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["approved_at"],
        sortDesc: ["true"]
      },
      visa: {},
      form: false,
      purpose_of_arrivals: [],
      payment_type: [
        { text: 'Gratis', value: 'gratis' },
        { text: 'Paid', value: 'paid' }
      ],
    };

  },

  components: {
    RefreshButton,
    OfficerSelectFilter,
    FileInput,
    CustomDateRangePicker,
    IssuedVisaFooter,
    ExportExcelButton,
    SidebarFilterButton
  },
  mixins: [commonStoreMixin, validationMixin],
  computed: {
    ...mapGetters({
      visa_types: "VisaTypeList/all",
      loading: "IssuedVisaReport/reportLoading",
      officers: "UserList/all",
      countries: "CountryList/all"
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    }
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries"
    }),
    view(item) {
      this.$router.push({
        name: "ViewVisaRequest",
        params: {id: item.submission_no}
      });
    },
    editVisa(item) {
      this.visa = item;
      this.form = true;
    },
    updateVisa() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        let formData = new FormData();
        formData.set('expiry_date', this.visa.expiry_date);
        formData.set('reason', this.visa.reason);
        // if(this.visa.visa)
        //     formData.set('visa', this.visa.visa);
        Http.post(`${VERSIONED_API_URL}/visa/change-expiry-date/${this.visa.id}`, formData)
            .then(() => {
              this.loading = false;
              this.form = false;
              this.$store.commit("Notification/showSuccess", "Visa Expiry Date changed successfully")
            })
            .catch(() => {
              this.loading = false;
              this.$store.commit("Notification/showError", "Something went wrong");
            })
      }
    },
    refreshData() {
      this.fetchData();
    },
  },

  mounted() {
    let params = this.$route.params;
    const query = this.$route.query;
    this.stateName = 'IssuedVisaReport';
    this.commonState = this.$store.state.IssuedVisaReport;
    this.fetchCountries();
    this.$store.dispatch('VisaTypeList/fetchAll');
    this.$store.dispatch("OfficeList/fetchData");
    if (params.fromRoute) {
      this.filters.date_range = {"start": params.start_date, "end": params.end_date}
    }
    if (query.start_date || query.end_date) {
      this.filters.date_range = {
        "start": query.start_date,
        "end": query.end_date,
      };
    }
    if (query.office) {
      this.filters.office = query.office;
    }else{
      this.filters.office = null;
    }
    if (query.country) {
      this.filters.country = Array.isArray(query.country)
          ? query.country.map(Number)
          : [Number(query.country)];
    }else {
      this.filters.country = null;
    }
    if(query.visa_type) {
      this.filters.visa_type = Array.isArray(query.visa_type)
          ? query.visa_type.map(Number)
          : [Number(query.visa_type)];
    }
    fetchDynamicValues('PurposeOfArrival').then((res) => {
      this.purpose_of_arrivals = res;
    })
    this.fetchData();

  }
};
</script>
